import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { SEHomeCard } from '../../../../common/components/SEHomeCard';
import { SlidingAnimationPageBase } from '../../../../common/components/SlidingAnimationPageBase';
import { useParamBackUrl } from '../../../../common/hooks/use-param-back-url';
import { AccountMenuButton } from '../../AccountMenuButton';
import { useLicenses } from './useLicenses';

export function LicensesPublishersList() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const licenses = useLicenses();
  const backURL = useParamBackUrl('../dashboard?direction=back');

  return (
    <SlidingAnimationPageBase title={t('Account.publishers')} backURL={backURL}>
      <Box px={5}>
        <SEHomeCard pr={0} pl={2} py={0} mb={4} borderTopLeftRadius="5px">
          {licenses.map(({ publisherId, publisher }, index) => (
            <AccountMenuButton
              key={publisherId}
              includeBottomDivider={index !== licenses.length - 1}
              data-testid={`license-publisher-button-${publisherId}`}
              onClick={() => {
                navigate(`${publisherId}`);
              }}
            >
              <Text fontSize={16} fontWeight="normal" overflow="auto">
                {publisher}
              </Text>
            </AccountMenuButton>
          ))}
        </SEHomeCard>
      </Box>
    </SlidingAnimationPageBase>
  );
}
